import { Column } from '@components/LinearLayout';
import {
  ButtonWrapper,
  ContentWrapper,
  DividerWrapper,
  SubtitleWrapper,
  TextWrapper,
  TitleText,
} from './styles';

import Divider from '@components/Divider';
import { useMobileWidth } from '@utils/hooks';
import UnderLine from '@components/Underline';
import { useSelector } from 'react-redux';
import { getEventDetails } from '@store/slices/eventSlice';

export interface ContentProps {
  titleColor: string;
  titleText: string;
  subtitleText: React.ReactNode | React.ReactNode[];
  themeColor: string;
  orientation?: string;
  button: React.ReactNode;
  extraContent?: React.ReactNode;
  padding?: string;
}

export const IllustratedTextContent = ({
  titleColor,
  titleText,
  subtitleText,
  themeColor,
  orientation = 'left',
  button,
  extraContent,
  padding,
}: ContentProps) => {
  const isMobile = useMobileWidth();
  const sluggedEvent = useSelector(getEventDetails)?.[0];

  const getJustifyContent = (orientation: string) => {
    if (orientation === 'left') return 'start';
    else if (orientation === 'right') return 'end';
    else return 'center';
  };

  return (
    <section>
      <ContentWrapper padding={padding}>
        <Column $gap={isMobile ? '2rem' : '3rem'}>
          <div>
            <TitleText color={titleColor} textAlign={orientation}>
              {titleText}
            </TitleText>

            <DividerWrapper justifyContent={getJustifyContent(orientation)}>
              <Divider
                width="12.3rem"
                height="0.4rem"
                backgroundColor={themeColor}
              />
            </DividerWrapper>

            <SubtitleWrapper>
              {Array.isArray(subtitleText) ? (
                <>
                  {subtitleText.map((itemText, index) => (
                    <TextWrapper
                      key={`subtitle-${index}`}
                      textAlign={orientation}
                    >
                      {itemText}
                    </TextWrapper>
                  ))}
                </>
              ) : (
                <TextWrapper textAlign={orientation}>
                  {subtitleText}
                </TextWrapper>
              )}
            </SubtitleWrapper>
          </div>
        </Column>

        <ButtonWrapper justifyContent={getJustifyContent(orientation)}>
          {button}
        </ButtonWrapper>
        {extraContent && extraContent}
      </ContentWrapper>
    </section>
  );
};

IllustratedTextContent.displayName = 'IllustratedTextContent';

export default IllustratedTextContent;
